var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contragents-row"},[_c('i-table',{attrs:{"show-header":false,"columns":_vm.columns,"data":_vm.row.contragents,"no-data-text":"Подрядчики отсутствуют"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }